<app-pop-up *ngIf="showPop">
  <app-pop-up-header [headerName]="'Logout'" [showCloseBtn]="false"></app-pop-up-header>
  <app-pop-up-body>
    <p>
      Your role has been changed by the BRRD Administrator, please log out and sign in again to the BRRD application.
    </p>
  </app-pop-up-body>
  <app-pop-up-footer>
    <app-button [name]="'logout'" [type]="'primary'" (btnClick)="logout()"></app-button>
  </app-pop-up-footer>
</app-pop-up>
